import { Layout, type LayoutProps } from "react-admin";
import { AdminMenu } from "./AdminMenu";

export const AdminLayout = (props: LayoutProps) => <Layout {...props} menu={AdminMenu} />;
